const Home = () => (
  <main>
    <div className="container padding">
      <h1>Welcome to our page</h1>

      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi vitae delectus tempore
        architecto eum accusamus eaque optio nemo unde quia officia iste, aspernatur suscipit
        eligendi. Minima minus magni excepturi dolore?
      </p>

      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit voluptatibus dolorum
        soluta adipisci facere quae dolore corporis esse deleniti quo beatae, molestias minus
        blanditiis et voluptatum odit assumenda quibusdam! Corporis, exercitationem vitae explicabo
        aliquam dolorum inventore eius expedita, aliquid tempora eum delectus aspernatur animi
        alias.
      </p>
    </div>
  </main>
);

export default Home;
